<template>
  <!-- 产品展示 - 主页面 -->
  <div class="exhibition_container">
    <div class="top-img_container">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <NavTools :displaySecNav="true" :displayBreadcrumb="true"></NavTools>
    <router-view></router-view>
  </div>
</template>

<script>
import DragCarousel from '@/components/drag-carousel/index.vue'
import NavTools from '@/layouts/components/NavTools.vue'

export default {
  components: { NavTools, DragCarousel },
  data() {
    return {
      imgData: [
        {
          src: require('@/assets/img/exhibition/bg.jpg'),
          alt: '产品展示'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.exhibition_container {
  width: 100%;
  height: 100%;
}
.top-img_container {
  margin-top: 80px;
  @media screen and (max-width: 768px) {
    margin: 0;
  }
}
</style>
